import React, { useEffect, useState, useContext, useMemo } from "react";
import { setMUIClassNamePrefix } from "@shared/MuiClassNameSetup";
import "./CoverageFinder/style.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import HCPCoverageFinder from "./CoverageFinder/HCP/HCPCoverageFinder";
import { AppSettingsService, CommonService, StyleService } from "@services";
import PatientCoverageFinder from "./CoverageFinder/Patient/PatientCoverageFinder";
import Analytics from "@norstella/nxp-ui-analytics";
import PatientFinder from "./PatientFinder/PatientFinder";
import LoaderWithIcon from "./CoverageFinder/CommonComponent/LoaderWithIcon";
import { ConfigurationContext } from "../contexts/Configuration";

const CoverageFinder = ({ token, indicationid, environment, zipCode, loadingIcon }) => {
  const [websiteType, setWebsiteType] = useState("1");
  const [projectType, setProjectType] = useState("6");
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const { setLoadingIcon } = useContext(ConfigurationContext);
  useMemo(() => {
    if (token) {
      const jwtProjectType = CommonService.parseJwt(token).projectType ?? 6;
      setMUIClassNamePrefix(jwtProjectType);
    }
  }, [token]);
  
  useEffect(() => {
    if (token) {
      const jwtPayload = CommonService.parseJwt(token);
      const tokenProducts = JSON.parse(jwtPayload.products);
      const jwtWebsiteType = jwtPayload.websiteType ?? 1;
      const jwtProjectType = jwtPayload.projectType ?? 6;
      const clientId = jwtPayload.clientId;
      
      AppSettingsService.getInstance().setEnvironmentAppSettings(environment, jwtWebsiteType);
      const cdnUrl = AppSettingsService.getInstance().getCDNUrl();
      if (loadingIcon) {
        setLoadingIcon(cdnUrl + "icons/" + clientId + "/" + loadingIcon);
      }
      setWebsiteType(jwtWebsiteType);
      setProjectType(jwtProjectType);
      setIsLoadingPage(false);
      if (tokenProducts.length === 1) {
        let fontProjectType = jwtProjectType == 8 ? jwtProjectType : null;
        StyleService.getInstance().loadCustomFonts(jwtPayload.clientId, cdnUrl, tokenProducts[0].ProductId, fontProjectType);
      }
    } else {
      AppSettingsService.getInstance().setEnvironmentAppSettings(environment, websiteType);
      console.log("Token is null or empty");
    }
  }, [token]);

  const analyticsConfig = {
    apiKey: AppSettingsService.getInstance().getPendoKey(),
    initConfig: {
      account: {
        id: CommonService.parseJwt(token).clientId,
      }
    }
  };

  const theme = createTheme({
    typography: {
      fontFamily: "inherit",
    },
  });

  return (
    <>
      {analyticsConfig?.apiKey && <Analytics provider="pendo" providerConfig={analyticsConfig} />}
      <ThemeProvider theme={theme}>
        {isLoadingPage && (
          <LoaderWithIcon />
        )}
        {!isLoadingPage && projectType == "6" && (websiteType == "1" || websiteType == "3") && (
          <HCPCoverageFinder token={token} indicationid={indicationid} zipCode={zipCode}></HCPCoverageFinder>
        )}
        {!isLoadingPage && projectType == "6" && (websiteType == "2" || websiteType == "4") && (
          <PatientCoverageFinder token={token} indicationid={indicationid}></PatientCoverageFinder>
        )}
        {!isLoadingPage && projectType == "8" && (websiteType == "2" || websiteType == "4") && (
          <PatientFinder token={token} indicationid={indicationid} zipCode={zipCode}></PatientFinder>
        )}
      </ThemeProvider>
    </>
  );
};

export default CoverageFinder;
